import { render, staticRenderFns } from "./UniversalSnackbar.vue?vue&type=template&id=cab73866&scoped=true"
import script from "./UniversalSnackbar.vue?vue&type=script&lang=js"
export * from "./UniversalSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab73866",
  null
  
)

export default component.exports